var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { QuestionAnswerState } from '../../../../classes/learnware/LearnwareEnums';
import { ShowQuestionAnswerBottomFeedback } from './AbfragerAnswerBottomFeedback';
import { ShowQuestionAnswerBottomAnswering } from './AbfragerAnswerBottomAnswering';
import { ShowQuestionAnswerBottomHistory } from './AbfragerAnswerBottomHistory';
let AbfragerQuestionAnswerBottom = class AbfragerQuestionAnswerBottom extends React.PureComponent {
    render() {
        const { question } = this.props;
        // const preloadedQuestionPersonal = question.streamedPersonalInAppScope;
        if (question.answer.answerInfo.isHistoricAnswer) {
            return React.createElement(ShowQuestionAnswerBottomHistory, { question: question });
        }
        if (question.answeringState.currentAnswerState === QuestionAnswerState.Feedback) {
            return React.createElement(ShowQuestionAnswerBottomFeedback, { question: question });
        }
        return React.createElement(ShowQuestionAnswerBottomAnswering, { question: question });
    }
};
AbfragerQuestionAnswerBottom = __decorate([
    observer
], AbfragerQuestionAnswerBottom);
export { AbfragerQuestionAnswerBottom };
